import api from "@/lib/api";
import { downloadFile } from "../../../services/downloads";

export const dealerAccess = async signal => (await api.get("/dealer/me", { signal })).data;
export const dealerStats = async signal => (await api.get("/dealer/stats", { signal })).data;
export const dealerInventory = async signal => (await api.get("/dealer/plots", { signal })).data;
export const dealerBookings = async signal => {
  const data = (await api.get("/dealer/bookings", { signal })).data;
  if (!Array.isArray(data) || data.some(row => typeof row?.id !== "string" || !row.id)) {
    throw new Error("Dealer booking list response could not be confirmed. Retry to load current payment balances.");
  }
  return data;
};

export const dealerDashboard = async signal => {
  const [me, stats, plots, bookings] = await Promise.all([
    api.get("/dealer/me", { signal }), api.get("/dealer/stats", { signal }),
    api.get("/dealer/plots", { signal }), api.get("/dealer/bookings", { signal }),
  ]);
  return { dealer: me.data.dealer, stats: stats.data, plots: plots.data, bookings: bookings.data };
};
export const dealerCommission = async (month, signal) => (await api.get("/dealer/commission", { params: { month }, signal })).data;
export const dealerLeaderboard = async (month, signal) => (await api.get("/leaderboard/dealers", { params: { month }, signal })).data;
export const downloadCommission = month => downloadFile(api, "/dealer/commission/statement.csv", `commission_${month}.csv`, { params: { month } });
export const createDealerBooking = async body => (await api.post("/dealer/bookings", body)).data;
export const listDealerBookingPlots = async (params, signal) =>
  (await api.get("/dealer/plots", { params: { bookable_only: true, page: 1, page_size: 50, include_block_counts: true, ...params }, signal })).data;
export const readDealerBookingAvailabilityCounts = async (params, signal) => {
  const result = await listDealerBookingPlots({ ...params, page: 1, page_size: 1 }, signal);
  return result.block_counts ?? null;
};
